import { render, staticRenderFns } from "./UX.vue?vue&type=template&id=64d76c40&scoped=true"
import script from "./UX.vue?vue&type=script&lang=js"
export * from "./UX.vue?vue&type=script&lang=js"
import style0 from "./UX.vue?vue&type=style&index=0&id=64d76c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d76c40",
  null
  
)

export default component.exports